<template>
  <div class="header">
    <div class="head-banner">
      <img
        :src="bannerImg[$t('lang')]"
        alt=""
      />
    </div>
    <div class="wrap">
      <div class="common-head">
        <h2 class="about-tit">
          <span>{{ $t("sial title") }} {{ $t("exhibitor title") }}</span>
        </h2>

        <el-steps
          :active="process"
          align-center
          class="reg-process"
          process-status="wait"
        >
          <el-step :title="$t('填写公司信息')" />
          <el-step :title="$t('注册成功')" />
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, reactive } from "vue";

defineProps({
  process: {
    type: Number,
    default: 1,
  },
});

const bannerImg = reactive({
  cn: `https://imgs.sialchina.cn/exhibitor/image/banner_cn.jpg?v=${new Date().getTime()}`,
  en: `https://imgs.sialchina.cn/exhibitor/image/banner_en.jpg?v=${new Date().getTime()}`
});
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  .head-banner {
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }
  .about-tit {
    position: relative;
    line-height: 1;
    text-align: center;
    font-size: 0;
    span {
      font-size: 24px;
      font-weight: bold;
      display: inline-block;
      background-color: #fff;
      padding: 0 10px;
      position: relative;
      z-index: 2;
      color: #333333;
    }
    // &:before{
    //     display: block;
    //     content: "";
    //     width: 100%;
    //     height: 3px;
    //     background-color: #cccccc;
    //     position: absolute;
    //     top: 50%;
    //     margin-top: -1px;
    //     left: 0;
    // }
  }
  .common-head {
    padding-top: 60px;
  }
}

:deep .reg-process {
  margin-top: 30px;
  .el-step__title {
    font-size: 15px;
    font-weight: bold;
    line-height: 1.5;
    margin-top: 5px;
  }

  .el-step__head.is-finish {
    color: @color1;
    border-color: @color1;

    .el-step__icon {
      background: #f9d1ca;
      box-shadow: 0 0 10px rgba(249, 209, 202, 0.6);
      position: relative;
      &:before {
        content: "";
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: @color2;
      }
    }
    .el-step__icon-inner {
      display: none;
    }
  }
  .el-step__title.is-finish {
    color: @color2;
  }

  .el-step.is-horizontal .el-step__line {
    background: #f4e9eb;
    height: 4px;
  }
  .el-step__line-inner {
    border-width: 2px !important;
  }
  .el-step__icon {
    background: @color1;
    color: #fff;
    border: 0 !important;

    width: 28px;
    height: 28px;
  }
  .el-step__icon-inner {
    font-weight: normal;
  }
}

@media screen and (max-width: 768px) {
  .header {
    .common-head {
      padding-top: 30px;
    }
  }
  .content .finish-img img {
    margin: 0 auto;
  }
}
</style>
